import { SlVueTreeNext } from 'sl-vue-tree-next'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('sl-vue-tree-next', SlVueTreeNext)
})